/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Json_JsonInputs */



/**
* | output |
* | --- |
* | "JSON (.json)" |
*
* @param {Json_JsonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const json_json = /** @type {((inputs?: Json_JsonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Json_JsonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("JSON (.json)")
	if (locale === "de") return /** @type {LocalizedString} */ ("JSON (.json)")
	if (locale === "it") return /** @type {LocalizedString} */ ("JSON (.json)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("JSON (.json)")
	if (locale === "es") return /** @type {LocalizedString} */ ("JSON (.json)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("JSON（.json）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("JSON (.json)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("JSON (.json)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("JSON (.json)")
	return /** @type {LocalizedString} */ ("JSON (.json)")
});